const quickAddMessages = {
  default: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="#ffffff"><path d="M7 14C7 14.1978 6.94135 14.3911 6.83147 14.5556C6.72159 14.72 6.56541 14.8482 6.38268 14.9239C6.19996 14.9996 5.99889 15.0194 5.80491 14.9808C5.61093 14.9422 5.43275 14.847 5.29289 14.7071C5.15304 14.5673 5.0578 14.3891 5.01921 14.1951C4.98063 14.0011 5.00043 13.8 5.07612 13.6173C5.15181 13.4346 5.27998 13.2784 5.44443 13.1685C5.60888 13.0586 5.80222 13 6 13C6.26522 13 6.51957 13.1054 6.70711 13.2929C6.89464 13.4804 7 13.7348 7 14ZM12.5 13C12.3022 13 12.1089 13.0586 11.9444 13.1685C11.78 13.2784 11.6518 13.4346 11.5761 13.6173C11.5004 13.8 11.4806 14.0011 11.5192 14.1951C11.5578 14.3891 11.653 14.5673 11.7929 14.7071C11.9327 14.847 12.1109 14.9422 12.3049 14.9808C12.4989 15.0194 12.7 14.9996 12.8827 14.9239C13.0654 14.8482 13.2216 14.72 13.3315 14.5556C13.4414 14.3911 13.5 14.1978 13.5 14C13.5 13.7348 13.3946 13.4804 13.2071 13.2929C13.0196 13.1054 12.7652 13 12.5 13ZM15.4819 5.13375L13.8794 10.9012C13.7913 11.2163 13.6028 11.494 13.3426 11.6923C13.0824 11.8906 12.7646 11.9986 12.4375 12H6.26C5.93189 11.9999 5.61284 11.8924 5.3515 11.694C5.09016 11.4956 4.90087 11.2172 4.8125 10.9012L2.62 3H1.5C1.36739 3 1.24021 2.94732 1.14645 2.85355C1.05268 2.75979 1 2.63261 1 2.5C1 2.36739 1.05268 2.24021 1.14645 2.14645C1.24021 2.05268 1.36739 2 1.5 2H3C3.10931 1.99998 3.21562 2.03578 3.30265 2.10193C3.38968 2.16808 3.45263 2.26092 3.48187 2.36625L4.07437 4.5H15C15.0771 4.49999 15.1531 4.51779 15.2222 4.55203C15.2912 4.58627 15.3515 4.63601 15.3981 4.69737C15.4448 4.75873 15.4766 4.83004 15.4911 4.90574C15.5057 4.98144 15.5025 5.05948 15.4819 5.13375ZM14.3419 5.5H4.3525L5.77812 10.6337C5.80737 10.7391 5.87032 10.8319 5.95735 10.8981C6.04438 10.9642 6.15069 11 6.26 11H12.4375C12.5468 11 12.6531 10.9642 12.7402 10.8981C12.8272 10.8319 12.8901 10.7391 12.9194 10.6337L14.3419 5.5Z" fill="%231C80C9"/></svg> Add',
  in_progress: 'Adding...',
  failed: 'Failed!',
  success: 'Added!'
};

// Handle quick add decrease qty button
function quickAddDecreaseQty(productId, widgetId = '') {
  var productIdFormatted = parseInt(productId),
    quickAddQtyInput = widgetId === '' ?
      document.querySelector('input[type="number"][data-product-id="' + productIdFormatted + '"].boost-sd__input-number-input') :
      document.querySelector('input[type="number"][data-product-id="' + productIdFormatted + '"][data-widget-id="' + widgetId + '"].boost-sd__input-number-input'),
    currentQuickAddQtyInputValue = parseInt(quickAddQtyInput.value),
    currentQuickAddQtyInputMin = parseInt(quickAddQtyInput.min);

  if (currentQuickAddQtyInputValue > currentQuickAddQtyInputMin) {
    currentQuickAddQtyInputValue--;
    quickAddQtyInput.value = currentQuickAddQtyInputValue;
  }
}

// Handle quick add increase qty button
function quickAddIncreaseQty(productId, widgetId = '') {
  var productIdFormatted = parseInt(productId),
    quickAddQtyInput = widgetId === '' ?
      document.querySelector('input[type="number"][data-product-id="' + productIdFormatted + '"].boost-sd__input-number-input') :
      document.querySelector('input[type="number"][data-product-id="' + productIdFormatted + '"][data-widget-id="' + widgetId + '"].boost-sd__input-number-input'),
    currentQuickAddQtyInputValue = parseInt(quickAddQtyInput.value),
    currentQuickAddQtyInputMax = parseInt(quickAddQtyInput.max);

  if (currentQuickAddQtyInputValue < currentQuickAddQtyInputMax) {
    currentQuickAddQtyInputValue++;
    quickAddQtyInput.value = currentQuickAddQtyInputValue;
  }
}

// Handle quick add add to cart button click
function quickAddAddToCart(productId, widgetId = '') {
  try {
    var productIdFormatted = parseInt(productId),
      quickAddQtyInput = widgetId === '' ?
        document.querySelector('input[type="number"][data-product-id="' + productIdFormatted + '"].boost-sd__input-number-input') :
        document.querySelector('input[type="number"][data-product-id="' + productIdFormatted + '"][data-widget-id="' + widgetId + '"].boost-sd__input-number-input'),
      quickAddAddedQty = quickAddQtyInput.value,
      boostProductItem = widgetId === '' ?
        document.querySelector('div[data-product-id="' + productId + '"].boost-sd__product-item') :
        document.querySelector('div[data-product-id="' + productId + '"][data-widget-id="' + widgetId + '"].boost-sd__product-item'),
      addToCartButton = widgetId === '' ?
        document.querySelector('button[data-product-id="' + productId + '"].quick-add-to-cart-button span') :
        document.querySelector('button[data-product-id="' + productId + '"][data-widget-id="' + widgetId + '"].quick-add-to-cart-button span'),
      productData = JSON.parse(boostProductItem.getAttribute('data-product')),
      selectedVariantTitle = null,
      selectedVariantId = null;

    productData.variants = JSON.parse(productData.variants);
  
    // console.log('quickAddQtyInput.value', quickAddQtyInput.value);
    // console.log('productData', productData);
  
    quickAddUpdateButtonStatus(addToCartButton, quickAddMessages.in_progress, true, false);

    productData.options_with_values.forEach((item, index) => {
      var optionName = item.name,
        selectedOptionLabel = widgetId === '' ?
          document.querySelector('label[role="radio"][data-product-id="' + productId + '"][data-option-name="' + optionName + '"].boost-sd__radio-label.boost-sd__radio-label--selected') :
          document.querySelector('label[role="radio"][data-product-id="' + productId + '"][data-widget-id="' + widgetId + '"][data-option-name="' + optionName + '"].boost-sd__radio-label.boost-sd__radio-label--selected'),
        selectedOptionValue = selectedOptionLabel.getAttribute('data-value').toLowerCase();
  
        if (selectedVariantTitle === null) {
          selectedVariantTitle = selectedOptionValue;
        } else {
          selectedVariantTitle += ' / ' + selectedOptionValue;
        }
    });
    // console.log('selectedVariantTitle', selectedVariantTitle);
  
    if (selectedVariantTitle !== null) {
      // Get the selected variant ID that will be added to the cart
      var selectedVariantInventory = null;
      productData.variants.every((item, index) => {
        var variantTitle = item.title.toLowerCase();
  
        if (variantTitle === selectedVariantTitle) {
          selectedVariantId = item.id;
          selectedVariantInventory = {
            inventory_quantity: item.inventory_quantity,
            inventory_management: item.inventory_management,
            inventory_policy: item.inventory_policy
          };
          return false;
        }
        return true;
      });
  
      // console.log('selectedVariantId', selectedVariantId);
      if (selectedVariantId !== null && selectedVariantInventory !== null) {
        // Add the selected variant to the cart
        quickAddCheckQty(
          selectedVariantId,
          selectedVariantInventory,
          quickAddAddedQty,
          addToCartButton
        );
      } else {
        // Variant not found
        quickAddUpdateButtonStatus(addToCartButton, quickAddMessages.failed, false, true);
        quickAddDisplayErrorNotification(window.quickAddToCartStrings.productAlertAddToCartError);
      }
    } else {
      // No options selected
      quickAddUpdateButtonStatus(addToCartButton, quickAddMessages.failed, false, true);
      quickAddDisplayErrorNotification(window.quickAddToCartStrings.productAlertAddToCartError);
    }
  } catch (e) {
    // Error
    console.error('Error:', e);
    quickAddUpdateButtonStatus(addToCartButton, quickAddMessages.failed, false, true);
    quickAddDisplayErrorNotification(window.quickAddToCartStrings.productAlertAddToCartError);
  }
}

// Check available qty before adding the product to the cart
function quickAddCheckQty(selectedVariantId, selectedVariantInventory, qtyAdded, addToCartButton) {
  qtyAdded = parseInt(qtyAdded, 10) || 1;

  // Enforce the cart / variant limits before checking stock.
  window.CartLimit.check(qtyAdded, { variantId: selectedVariantId }).then((limitResult) => {
    if (!limitResult.allowed) {
      window.CartLimit.notify(limitResult.message);
      quickAddUpdateButtonStatus(addToCartButton, quickAddMessages.default, false, false);
      return;
    }
    quickAddCheckInventory(selectedVariantId, selectedVariantInventory, qtyAdded, addToCartButton);
  });
}

function quickAddCheckInventory(selectedVariantId, selectedVariantInventory, qtyAdded, addToCartButton) {
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    return response.json();;
  })
  .then(response => {
    // console.log('response', response);
    if (response.items !== undefined && response.items !== null) {
      if (response.items.constructor === Array) {
        var currentQtyInCart = 0
        if (response.items.length) {
          response.items.every((item, index) => {
            if (item.id == selectedVariantId) {
              currentQtyInCart = item.quantity;
              return false;
            }
            return true;
          });
        }

        var totalInCart = currentQtyInCart + qtyAdded;
        // console.log('totalInCart', totalInCart);
        // console.log('selectedVariantInventory', selectedVariantInventory);

        if (selectedVariantInventory.inventory_quantity >= totalInCart ||
          selectedVariantInventory.inventory_policy === 'continue' ||
          selectedVariantInventory.inventory_management === ''
        ) {
          quickAddToCartApiRequest(selectedVariantId, qtyAdded, addToCartButton);
        } else if (selectedVariantInventory.inventory_quantity <= currentQtyInCart) {
          quickAddDisplayErrorNotification(window.quickAddToCartStrings.productAlertMaxProductAddedToTheCart);
          quickAddUpdateButtonStatus(addToCartButton, quickAddMessages.failed, false, true);
        } else {
          if (currentQtyInCart === 0) {
            var errorMessage = window.quickAddToCartStrings.productAlertQtyAddedExceedsTheMaximumWhenItemHasNotBeenAdded;
          } else {
            var errorMessage = window.quickAddToCartStrings.productAlertQtyAddedExceedsTheMaximum;
          }
          var errorMessageReplace = errorMessage.replace('qty', (selectedVariantInventory.inventory_quantity - currentQtyInCart) + '');
          quickAddDisplayErrorNotification(errorMessageReplace);
          quickAddUpdateButtonStatus(addToCartButton, quickAddMessages.failed, false, true);
        }

      } else {
        // Error
        quickAddDisplayErrorNotification(window.quickAddToCartStrings.productAlertAddToCartError);
      }
    } else {
      // Error
      quickAddDisplayErrorNotification(window.quickAddToCartStrings.productAlertAddToCartError);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Call API add to cart process
function quickAddToCartApiRequest(selectedVariantId, qtyAdded, addToCartButton) {
  let formData = {
    'items': [{
      'id': selectedVariantId,
      'quantity': qtyAdded
    }]
  };
   
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(response => {
    // console.log('response', (response));
    // console.log('response.items', response.items);
    if (response.items !== undefined) {
      window.CartLimit.refresh();
      quickAddRefreshCartItems(response);
      quickAddUpdateButtonStatus(addToCartButton, quickAddMessages.success, false, true);
    } else {
      quickAddUpdateButtonStatus(addToCartButton, quickAddMessages.failed, false, true);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    quickAddDisplayErrorNotification(window.quickAddToCartStrings.productAlertAddToCartError);
  });
}

// Refresh cart items process
function quickAddRefreshCartItems(addToCartSuccessResponse) {
  var productAddToCartNotificationWrapper = document.querySelector('.product-add-to-cart-notification-wrapper');
  if (productAddToCartNotificationWrapper !== null && productAddToCartNotificationWrapper !== undefined) {
    // Display the product add to cart notification
    productAddToCartNotificationWrapper.style.display = 'block';
    setTimeout(function () {
      productAddToCartNotificationWrapper.style.display = 'none';
    }, 3000);

    // Refresh the cart drawer & cart icon bubble contents
    // Follow the logic on the theme code assets/cart-drawer.js
    // Since on the data respons there's no sections attribute (That is used for rerender the cart drawer & cart icon bubble),
    // we will load them manually
    fetch('/?sections=cart-drawer,cart-icon-bubble', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then(response => {
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var cartSections = response;
      var cartData = addToCartSuccessResponse.items[0];
      cartData.sections = cartSections;
      cart.renderContents(cartData, false);
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
}

// Update add to cart button label & disabled status
function quickAddUpdateButtonStatus(addToCartButton, updatedLabel, isDisabled, loadDefaultLabelLaterOn = false) {
  addToCartButton.disabled = isDisabled;
  addToCartButton.innerText = updatedLabel;

  if (loadDefaultLabelLaterOn) {
    setTimeout(function () {
      addToCartButton.innerHTML = quickAddMessages.default;
    }, 1000);
  }
}

// Show/display product add to cart 
function quickAddDisplayErrorNotification(message) {
  var productErrorAddToCartNotificationWrapper = document.querySelector('.product-error-add-to-cart-notification-wrapper');
  if (productErrorAddToCartNotificationWrapper === null || productErrorAddToCartNotificationWrapper === undefined) {
    window.CartLimit.popup(message);
    return;
  }
  if (productErrorAddToCartNotificationWrapper !== null && productErrorAddToCartNotificationWrapper !== undefined) {
    var productErrorAddToCartNotificationWrapperMessage = productErrorAddToCartNotificationWrapper.querySelector('span');
    productErrorAddToCartNotificationWrapperMessage.innerText = message;
    productErrorAddToCartNotificationWrapper.style.display = 'block';
    setTimeout(function () {
      productErrorAddToCartNotificationWrapper.style.display = 'none';
      productErrorAddToCartNotificationWrapperMessage.innerText = '';
    }, 3000);
  }
}